import React from "react";
import { Header, InDevelopmentPage } from "../components";

const Clients = () => {
  return (
    <>
      <div className="m-10 mt-5 p-10 pt-6 bg-white dark:bg-main-dark-bg rounded-3xl">
        {/* Showing data saved correctly */}
        <div className="mb-5 flex justify-between">
          <Header category="Página" title="Clientes" />
        </div>
        <InDevelopmentPage />
        <div className=""></div>
      </div>
    </>
  );
};

export default Clients;
